import { Global, css } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';
import React from 'react';

const AppGlobalStyles: React.FC = () => (
	<>
		<Global
			styles={css`
				${emotionNormalize}
			`}
		/>
		<Global
			styles={css`
				/* latin-ext */
				@font-face {
					font-family: 'DMSans';
					font-style: italic;
					font-weight: 500;
					font-display: swap;
					src: url(https://fonts.gstatic.com/s/dmsans/v16/rP2Wp2ywxg089UriCZaSExdy3sGt9zz86FHwyKK58UfivUw4aw.woff2)
						format('woff2');
					unicode-range:
						U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF,
						U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF,
						U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
				}
				/* latin */
				@font-face {
					font-family: 'DMSans';
					font-style: italic;
					font-weight: 500;
					font-display: swap;
					src: url(https://fonts.gstatic.com/s/dmsans/v16/rP2Wp2ywxg089UriCZaSExdy3sGt9zz86FHwyKy58UfivUw.woff2)
						format('woff2');
					unicode-range:
						U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
						U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191,
						U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
				}
				/* latin-ext */
				@font-face {
					font-family: 'DMSans';
					font-style: normal;
					font-weight: 500;
					font-display: swap;
					src: url(https://fonts.gstatic.com/s/dmsans/v16/rP2Yp2ywxg089UriI5-g7M8btVsD8CkGq7u6-K6z9mXgjU0.woff2)
						format('woff2');
					unicode-range:
						U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF,
						U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF,
						U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
				}
				/* latin */
				@font-face {
					font-family: 'DMSans';
					font-style: normal;
					font-weight: 500;
					font-display: swap;
					src: url(https://fonts.gstatic.com/s/dmsans/v16/rP2Yp2ywxg089UriI5-g7M8btVsD8CkGq7u0-K6z9mXg.woff2)
						format('woff2');
					unicode-range:
						U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
						U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191,
						U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
				}
			`}
		/>
		{APP_MODE === 'app' && (
			<>
				<Global
					styles={css`
						html,
						body,
						#root {
							width: 100%;
							height: 100%;
							padding: 0;
							margin: 0;
							overflow: hidden;
						}
					`}
				/>
				<Global
					styles={css`
						body {
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
						}
					`}
				/>
				<Global
					styles={css`
						* {
							box-sizing: border-box;
						}
					`}
				/>
			</>
		)}
	</>
);

export default AppGlobalStyles;
